import { isPublicationInProgress } from 'utils/isPublicationInProgress';

import { DocumentModel } from 'api/documents/documents.model';
import { useCertificateQuery } from 'hooks/useCertificateQuery';
import { CertificateDetailsModel } from 'models/certificate.model';

import * as Styled from './TableCellWithPublicationStatus.styles';

const TableCellWithPublicationStatus = (
  value: string,
  { documentPublicationStatus, jobId }: DocumentModel<CertificateDetailsModel>
) => {
  const { data: document } = useCertificateQuery(jobId, {
    enabled: isPublicationInProgress(documentPublicationStatus),
    refetchInterval: (response) => {
      if (response && isPublicationInProgress(response.documentPublicationStatus)) {
        return 2000;
      }

      return false;
    },
  });

  return (
    <>
      {document && isPublicationInProgress(document.documentPublicationStatus) && (
        <Styled.Spinner />
      )}
      {value}
    </>
  );
};

export default TableCellWithPublicationStatus;
